import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

type StyledHeaderApplicationProps = {
  $hasStateSelectorAuth?: boolean;
  $isGettingStartedPageHidden?: boolean;
};

function isGettingStartedPageHiddenStyle({ $isGettingStartedPageHidden = false }: StyledHeaderApplicationProps) {
  if ($isGettingStartedPageHidden) {
    return css`
      padding-bottom: 0;

      span {
        margin-bottom: 1rem;
      }
    `;
  }
}

function hasStateSelectorAuthStyle({ $hasStateSelectorAuth = false }: StyledHeaderApplicationProps) {
  if ($hasStateSelectorAuth) {
    return css`
      width: 100%;
    `;
  }
}

export default styled.div<StyledHeaderApplicationProps>`
  display: flex;
  font-size: 0.8rem;
  line-height: 1.5;
  color: ${Colours.white};
  justify-content: space-between;
  width: 60%;

  strong {
    font-weight: 700;
  }

  padding-bottom: 2rem;

  span {
    color: ${Colours.white};
    margin-bottom: 0.5rem;
  }

  ${isGettingStartedPageHiddenStyle}
  ${hasStateSelectorAuthStyle}
`;
